<template>
  <div class="archives">
    <div class="archive-item" :key="archive.id" v-for="archive of archives">
      <a :href="archiveHref(archive.id)" target="_blank">{{ archive.name }}</a>
      <DeleteIconButton
        v-if="deletable"
        @delete="$emit('delete', archive)"
      ></DeleteIconButton>
    </div>
  </div>
</template>

<script>
import DeleteIconButton from "@/components/DeleteIconButton";
export default {
  name: "ArchivesList",
  props: {
    archives: {
      type: Array,
      default: () => []
    },
    deletable: {
      type: Boolean
    }
  },
  components: {
    DeleteIconButton
  },
  methods: {
    archiveHref(id) {
      return `/api/v1/archives/${id}`;
    }
  }
};
</script>

<style scoped lang="scss">
.archives {
  min-height: 1.9rem;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  transition: 0.5s;
}
.archive-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 250px;
  padding: 5px 10px;
  border-bottom: 1px solid #dcdfe6;
  & a {
    text-decoration: none;
    color: #54a0ff;
    padding-right: 5px;
  }
}
</style>
